import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenLoading } from "@/components/common/Loading";
import { supabase } from "@/lib/supabase";

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase auto-detect le hash. On laisse onAuthStateChange déclencher la redirection.
    supabase.auth.getSession().then(({ data, error }) => {
      if (error || !data.session) {
        navigate("/welcome", { replace: true });
        return;
      }
      navigate("/", { replace: true });
    });
  }, [navigate]);

  return <FullScreenLoading />;
}
